const QUEUE_KEY = 'attendance_offline_queue';

const readQueue = () => {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeQueue = (items) => {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(items));
};

const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const dataUrlToFile = (dataUrl, filename = 'offline.jpg') => {
  if (!dataUrl || typeof dataUrl !== 'string') return null;
  const parts = dataUrl.split(',');
  if (parts.length < 2) return null;
  const mimeMatch = parts[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
  const bytes = atob(parts[1]);
  const arr = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) arr[i] = bytes.charCodeAt(i);
  return new File([arr], filename, { type: mime });
};

export const enqueueAttendance = async (payload, imageFile) => {
  const queue = readQueue();
  const imageDataUrl = imageFile ? await fileToDataUrl(imageFile) : null;
  queue.push({
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: Date.now(),
    payload,
    imageDataUrl,
  });
  writeQueue(queue);
};

export const getQueueSize = () => readQueue().length;

export const flushAttendanceQueue = async (submitFn) => {
  const queue = readQueue();
  if (!queue.length) return { sent: 0, failed: 0 };

  const remain = [];
  let sent = 0;

  for (const item of queue) {
    try {
      const payload = { ...item.payload };
      if (item.imageDataUrl) {
        payload.image = dataUrlToFile(item.imageDataUrl, `${payload.type || 'attendance'}_${item.createdAt}.jpg`);
      }
      await submitFn(payload);
      sent += 1;
    } catch {
      remain.push(item);
    }
  }

  writeQueue(remain);
  return { sent, failed: remain.length };
};
